import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private http = inject(HttpClient);

  get<T>(url: string): Observable<T> {
    return this.http.get<T>(`${environment.apiUrl}/${url}`);
  }

  getWithParams<T>(url: string, params: Record<string, unknown>): Observable<T> {
    let httpParams = new HttpParams();
    for (const key of Object.keys(params)) {
      const value = params[key];
      if (value !== null && value !== undefined && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    }
    return this.http.get<T>(`${environment.apiUrl}/${url}`, {
      params: httpParams,
      observe: 'response' as const,
    }) as unknown as Observable<T>;
  }

  getWithParamsResponse(url: string, params: Record<string, unknown>) {
    let httpParams = new HttpParams();
    for (const key of Object.keys(params)) {
      const value = params[key];
      if (value !== null && value !== undefined && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    }
    return this.http.get(`${environment.apiUrl}/${url}`, {
      params: httpParams,
      observe: 'response',
    });
  }

  post<T>(url: string, body: unknown): Observable<T> {
    return this.http.post<T>(`${environment.apiUrl}/${url}`, body);
  }

  postWithResponse(url: string, body: unknown) {
    return this.http.post(`${environment.apiUrl}/${url}`, body, { observe: 'response' });
  }

  /** POST that returns a file (e.g. a CSV export) with headers, so callers can read Content-Disposition. */
  postForBlob(url: string, body: unknown) {
    return this.http.post(`${environment.apiUrl}/${url}`, body, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  /** GET that returns a file with headers, so callers can read Content-Disposition. */
  getBlob(url: string) {
    return this.http.get(`${environment.apiUrl}/${url}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  put<T>(url: string, body: unknown): Observable<T> {
    return this.http.put<T>(`${environment.apiUrl}/${url}`, body);
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(`${environment.apiUrl}/${url}`);
  }
}
